import { ContentfulButton } from '@jbhi-fi/apis/src/contentful/types';
import React from 'react';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { AlignedButtonProps } from '../../AlignedButton/AlignedButton';
import { GoToLinkProps } from '../../GoToLink/GoToLink';

export type LanyardButtonProps = Parameters<typeof JBButton>[0];

export const buttonOnClickHandler = (event: React.MouseEvent, href: string, shouldOpenInNewWindow?: boolean) => {
  event.preventDefault();
  if (shouldOpenInNewWindow) {
    window.open(href, '_blank')?.focus();
  } else {
    window.location.assign(href);
  }
};

const mergeFields = {
  currentUrl: window.location.href,
};

const replaceFields = (url: string) => {
  return url.replace(/{(.*?)}/g, (match, key) => {
    return mergeFields[key as keyof typeof mergeFields] || match;
  });
};

export abstract class ButtonTransformer {
  static toClickHandler = ({
    href,
    shouldOpenInNewWindow = false,
  }: {
    href: string;
    shouldOpenInNewWindow?: boolean;
  }) => {
    return (event: React.MouseEvent) => {
      buttonOnClickHandler(event, href, shouldOpenInNewWindow);
    };
  };

  static toLanyardButtonProps = (entry: ContentfulButton): LanyardButtonProps => {
    const type = entry?.fields?.type?.toLowerCase() === 'green' ? 'action' : entry?.fields?.type?.toLowerCase();
    return {
      onClick: this.toClickHandler({
        href: replaceFields(entry?.fields?.url ?? ''),
        shouldOpenInNewWindow: entry?.fields?.shouldOpenInNewWindow,
      }),
      label: entry?.fields?.label,
      type: type as LanyardButtonProps['type'],
      icon: entry?.fields?.icon?.fields?.name ? <Icon name={entry.fields.icon.fields.name} /> : undefined,
      iconPosition: 'left',
      name: entry.fields?.name,
    };
  };

  static toAlignedButtonProps = (entry: ContentfulButton): AlignedButtonProps => {
    return { ...this.toLanyardButtonProps(entry), alignment: entry?.fields?.alignment };
  };

  static toGoToLinkProps = (entry: ContentfulButton): GoToLinkProps => {
    return {
      href: replaceFields(entry?.fields?.url ?? ''),
      label: entry.fields?.label ?? '',
      shouldOpenInNewWindow: entry.fields?.shouldOpenInNewWindow,
    };
  };
}
